<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
  <div>
  <img style="width: 100%;" :src="info.defImg" mode="widthFix" />
<!-- 年 -->
<div class="flex grid col-2 margin-top bg-e">
  <div class=" text-bold text-xl padding text-center " :class="TabCur==0? 'bg-white text-orange on':'text-black'" @click="tabSelect(0)" >
    {{goodsAttributes[0].key}}
  </div>
  <div class="text-bold text-xl padding text-center" :class="TabCur==1? 'bg-white text-orange on':'text-black'" @click="tabSelect(1)" >
    {{goodsAttributes[1].key}} </div>
</div>
<div v-if="TabCur==0" class=" bg-white ">
  <div class=" text-black padding-top text-xl text-center">{{goodsAttributes[0].title||''}}</div>
  <div class="flex flex flex-wrap padding-sm b-b">
    <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[0].values" :key="index"  @click="pageJump('/buyYx',0,index)" >{{item}}</div>
  </div>
  <!-- 详情图 -->
  <img style="width: 100%;" mode="widthFix" v-for="(item, index) in info.goodsDetailImgs" :key="index" :src="item" />
</div>
<!-- 详情 -->
<div v-if="TabCur==1" class=" bg-white ">
  <div class=" text-black padding-top text-xl text-center">{{goodsAttributes[1].title||''}}</div>
  <div class="flex flex flex-wrap padding-sm b-b">
    <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[1].values " :key="index"  @click="pageJump('/buyYx',1,index)" >{{item}}</div>
  </div>
  <!-- <div class="padding "> <text class="text-black text-bold margin-right-xs">时间</text><text> 6 月</text> </div> -->
  <!-- 详情图 -->
  <img style="width: 100%;"  mode="widthFix" v-for="(item, index) in info.goodsDetailImgs" :key="index" :src="item" />
</div>
<div style="height: 250rpx;"></div>

<!-- 购买按钮 -->
<div class="padding-xl " @click="showModal()" style="position: fixed;bottom: 0;width: 100%;background-color: white; letter-spacing: 2rpx;">
  <div class="an_shop text-bold" style="width: 100%;">立即报名</div>
</div>
<!-- 底部弹框 -->
<div class="cu-modal bottom-modal" :class="modalName=='bottomModal'?'show':''" bindtap="hideModal" v-if="modalName=='bottomModal'">
  <div class="cu-dialog" style="border-radius: 30rpx 30rpx 0 0;">
    <div class="bg-white padding-top-xs text-right padding-right-sm">
      <div class="action" bindtap="hideModal">
        <text class="cuIcon-close text-black text-bold" style="font-size: 43rpx;"></text>
      </div>
    </div>
    <div v-if="TabCur==0" class=" bg-white ">
      <div class=" text-black text-xl text-center">{{goodsAttributes[0].key}}</div>
      <div class="bg-orange round text-xl text-center" style=" margin:20rpx 120rpx 0 120rpx;">{{goodsAttributes[0].title||''}}</div>
      <div class="flex flex-wrap padding-lr-sm ">
        <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[0].value" :key="index" @click="pageJump('/buyYx',0,index)" >{{item}}</div>
      </div>
      <div style="height: 80rpx;"></div>
    </div>
    <!-- 详情 -->
    <div v-if="TabCur==1" class=" bg-white ">
      <div class=" text-black text-xl text-center">{{goodsAttributes[1].key}}</div>
      <div class="bg-orange round text-xl text-center" style=" margin:20rpx 120rpx 0 120rpx;">{{goodsAttributes[1].title||''}}</div>
      <div class=" flex flex-wrap padding-lr-sm">
        <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[1].values" :key="index"  @click="pageJump('/buyYx',1,index)">{{item}}</div>
      </div>
      <div style="height: 80rpx;"></div>

    </div>
  </div>
</div>
</div>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'yx',
  data () {
    return {
      requestHeadUrl: 'https://zhenqing.kequbang.com',
      // requestHeadUrl: 'http://localhost:8122',
      isOpenVipModular: false,
      isVip: 0,
      storeId: '',
      userId: '',
      isMiniProgram: true,
      appLink: '',
      info: {},
      goodsAttributes: [],
      TabCur:0,
      modalName: ''
    }
  },
  created () {
    const thisObj = this
    thisObj.onLoad()
  },
  methods: {
    onLoad: function () {
      // const payParam = {
      //       appId: 'wxa55c200673db6dc7',
      //       package: 'result.resultData.package',
      //       paySign: 'result.resultData.sign',
      //       signType: 'MD5',
      //       timeStamp: 'result.resultData.timeStamp',
      //       nonceStr: 'result.resultData.nonceStr'
      //     }
      // this.navigateToMiniProgram(JSON.stringify(payParam))
      var rr = window.location.href.split('/')
      //9d03442a91c345709dcbcd85daab9cc4
      var gid = rr[rr.length-1].split('-')[0]
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/p/goods/getByGoodId?goodId='+ gid +'&storeId=storezhenqing&linkId='+rr[rr.length-1], {}).then(res => {
        // console.log(res)
        res.goodsImgs = res.goodsImgs.split(",");
        res.goodsDetailImgs = res.goodsDetailImgs.split(",");
        thisObj.info = res 
        thisObj.goodsAttributes = JSON.parse(res.goodsAttributes)
        // console.log(thisObj.info)
        // console.log(thisObj.goodsAttributes)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
      
      // thisObj.$api.get(thisObj.requestUrl + '/auth/knowledge/dy/app/openlink?fromDevice=h5&knowledgeOpenPersonId=1', {}).then(res => {
      //   // console.log(res)
      //   if (res.resultCode === 200 && res.success) {
      //     console.log(res) 
      //   } else {
      //     thisObj.$util.requetServerError(res.resultMsg)
      //   }
      // }).catch(function (error) {
      //   thisObj.$util.requetServerError(error)
      // })
      // thisObj.$api.get(thisObj.requestUrl + '/auth/knowledge/dy?fromDevice=h5&knowledgeOpenPersonId=1', {}).then(res => {
      //   // console.log(res)
      //   if (res.resultCode === 200 && res.success) {
      // // location.href=res.resultData.openlink;
      //     wx.config({
      //       debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印
      //       appId: 'wxa55c200673db6dc7', // 必填，公众号的唯一标识
      //       timestamp: res.resultData.timestamp, // 必填，生成签名的时间戳
      //       nonceStr: res.resultData.nonceStr, // 必填，生成签名的随机串
      //       signature: res.resultData.signature,// 必填，签名
      //       jsApiList: ['onMenuShareTimeline'], // 必填，需要使用的 JS 接口列表
      //       openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      //     });
      //     wx.ready(function () {
      //       console.log('ok')
      //       // config信息验证后会执行 ready 方法，所有接口调用都必须在 config 接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在 ready 函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在 ready 函数中
      //     });
      //     wx.error(function (res) {
      //       alert(res)
      //       // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名
      //       console.log('error')
      //       console.log(res)
      //     });
      //   } else {
      //     thisObj.$util.requetServerError(res.resultMsg)
      //   }
      // }).catch(function (error) {
      //   thisObj.$util.requetServerError(error)
      // })
      // return
    },
    goApp() {
      location.href=this.appLink
    },
    tabSelect(e) {
      this.TabCur = e
    },
    // showModal() {
    //   this.modalName = 'bottomModal'
    // },
    // 页面跳转
    pageJump (uri, obj,index) {
      const thisObj = this
      var that = this;
    var info = that.info
    var goodsAttributes = that.goodsAttributes
      let queryData = {
        goodsName: info.goodsName,
        title: goodsAttributes[obj].title,
        values: goodsAttributes[obj].values[index],
        valueKey: goodsAttributes[obj].valueKey[index],
        price: info.groupBuyingPrice
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    
  }
}
</script>

<style>
.bg-e {
  background: #eeeeee;
}
.margin-top {
    margin-top: 30px;
}
.grid {
    display: flex;
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.grid.col-2>div {
    width: 50%;
}
.text-orange, .line-orange, .lines-orange {
    color: var(--orange);
}
.text-center {
    text-align: center;
}
.text-bold {
    font-weight: bold;
}
.text-xl {
    font-size: 36px;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding {
    padding: 30px;
}
.padding-top {
    padding-top: 30px;
}
.b-b {
    border-bottom: 2px solid #CFCFCF;
}
.padding-sm {
    padding: 20rpx;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.text-bold {
    font-weight: bold;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.cu-modal.bottom-modal.show {
    margin-bottom: 0;
}
.cu-modal.show {
    opacity: 1;
    transition-duration: 0.3s;
    -ms-transform: scale(1);
    transform: scale(1);
    overflow-x: hidden;
    overflow-y: auto;
    pointer-events: auto;
}
.cu-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1110;
    opacity: 0;
    outline: 0;
    text-align: center;
    -ms-transform: scale(1.185);
    transform: scale(1.185);
    backface-visibility: hidden;
    perspective: 2000rpx;
    background: rgba(0, 0, 0, 0.6);
    transition: all 0.3s ease-in-out 0s;
    pointer-events: none;
}
.padding-right-sm {
    padding-right: 20rpx;
}
.padding-top-xs {
    padding-top: 10rpx;
}
.bg-orange {
    background-color: #f37b1d;
    color: #ffffff;
}
.an_shop {
  width: 100%;
  line-height: 80px;
  color: #fff;
  background-color: #ff6600;
  border-radius: 30px;
  text-align: center;
  font-size: 36px;
}

.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}

.shuxing {
  color: #ff6600;
  font-size: 33rpx;
  width: 29%;
  margin: 12px;
  border-radius: 20px;
  padding: 20px 8px;
  margin-top: 30px;
  background-color: #ffefe4;
  border: 2px solid #ff6600;
}
</style>
